import React from 'react';

const Guide = () => {
  // Custom CSS for matching the home page style
  const styles = `
    .guide-hero-section {
      background: linear-gradient(to bottom right, #fee2e2, #ffffff, #dbeafe);
    }
    .guide-nav .nav-link {
      color: #6c757d;
      font-weight: 500;
      padding: 0.5rem 1rem;
      border-left: 3px solid transparent;
    }
    .guide-nav .nav-link.active,
    .guide-nav .nav-link:hover {
      color: #dc2626;
      border-left-color: #dc2626;
      background-color: #fee2e2;
    }
    .guide-content h3 {
      font-weight: 700;
      color: #007bff;
      margin-bottom: 1.5rem;
      padding-bottom: 0.5rem;
      border-bottom: 2px solid #f3f4f6;
    }
    .guide-content h4 {
      font-weight: 600;
      color: #28a745;
      margin-top: 2rem;
      margin-bottom: 1rem;
    }
    .important-text {
      color: #dc2626;
      font-weight: 600;
    }
    .draft-example {
      background-color: #f8f9fa;
      border: 1px solid #dee2e6;
      border-radius: 0.5rem;
    }
    .point-plus {
      color: #198754; /* Bootstrap success color */
      font-weight: 600;
    }
    .point-minus {
      color: #dc3545; /* Bootstrap danger color */
      font-weight: 600;
    }
    .table {
      font-size: 0.95rem;
    }

   
  `;

  return (
    <>
      <style>{styles}</style>
      
      {/* Hero Section */}
      <section className="guide-hero-section py-5">
        <div className="container text-center">
          <h1 className="display-5 fw-bold">플레이볼 판타지 게임 가이드</h1>
          <p className="lead text-muted">KBO 판타지 야구를 더욱 즐겁게 즐기기 위한 모든 정보가 여기 있습니다.</p>
        </div>
      </section>

      {/* Guide Content Section */}
      <section className="py-5">
        <div className="container">
          <div className="row">
            {/* Sidebar Navigation */}
            <div className="col-lg-3 d-none d-lg-block">
              <nav id="guide-nav" className="nav flex-column guide-nav position-sticky" style={{top: '6rem'}}>
                <a className="nav-link" href="#section-1">위클리 리그</a>
                <a className="nav-link" href="#section-2">웹사이트 이용</a>
                <a className="nav-link" href="#section-3">드래프트 가이드</a>
                <a className="nav-link" href="#section-4">선수 교체/영입</a>
                <a className="nav-link" href="#section-5">게임 진행</a>
                <a className="nav-link" href="#section-6">팀 관리</a>
              </nav>
            </div>

            {/* Main Guide Content */}
            <div className="col-lg-9 guide-content">
              {/* Section 1 */}
              <div id="section-1" className="mb-5">
                <h3>1. 위클리 플레이볼 리그</h3>
                <h4>1.1 진행 방식</h4>
                <ul>
                  <li><strong>진행 기간:</strong> 각 리그는 짜릿한 1주일 동안 진행됩니다.</li>
                  <li><strong>드래프트:</strong> 매주 일요일 저녁 5시부터 당신의 운명을 결정할 드래프트가 펼쳐집니다.</li>
                  <li><strong>경기 반영:</strong> 화요일부터 월요일까지, KBO 리그의 실제 경기 결과를 바탕으로 순위가 실시간으로 변동됩니다.</li>
                  <li><strong>참가 인원:</strong> 각 리그는 8명의 구단주님들과 함께합니다.</li>
                </ul>
                <h4>1.2 리그 종류</h4>
                <ul>
                  <li><strong>퍼블릭 리그:</strong> 다른 구단주님들과 자동으로 매칭되어 함께 경쟁하는 공식 리그입니다.</li>
                  <li><strong>커스텀 리그:</strong> 친구, 가족들과 함께 특별한 리그를 만들고 싶으신가요? 커스텀 리그를 이용해보세요.</li>
                </ul>
              </div>

              {/* Section 2 */}
              <div id="section-2" className="mb-5">
                <h3>2. 웹사이트 이용 방법</h3>
                <h4>2.1 시작하기</h4>
                <p>'플레이볼 판타지' 메인 화면의 "지금 바로 시작하기" 버튼을 클릭하여 회원 가입 페이지로 이동하세요!</p>
                <h4>2.2 회원 가입 및 로그인</h4>
                <p>카카오톡, 네이버 등 사용하시는 SNS 계정으로 간편하게 연동하여 회원 가입 및 로그인이 가능합니다.</p>
                <h4>2.3 리그 신청 방법</h4>
                <p>로그인 후, 메인 페이지에서 바로 리그를 신청할 수 있습니다. 위클리 플레이볼 리그는 매주 화요일부터 일요일까지 새로운 리그 신청을 받습니다. 새로운 퍼블릭 리그의 드래프트는 일요일 오후 5시에 진행되니, <span className="important-text">잊지 말고 참여하세요!</span></p>
              </div>

              {/* Section 3 */}
              <div id="section-3" className="mb-5">
                <h3>3. 드래프트 가이드</h3>
                <p>드래프트는 당신의 야구 지식과 전략적 사고를 발휘하여 꿈꿔왔던 KBO 드림팀을 현실로 만드는 짜릿한 경험입니다. 상대방이 호시탐탐 노리는 1급 선수를 낚아채는 쾌감, 치열한 수 싸움 끝에 완성되는 나만의 라인업은 그 어떤 승리보다 달콤한 보상을 선사합니다.</p>
                
                <h4>3.1 팀 구성하기 (스네이크 드래프트)</h4>
                <p>스네이크 드래프트는 뱀이 움직이는 모양처럼, 지그재그 순서로 선수를 선발하는 방식입니다. 드래프트 순서는 게임 시작 전 AI가 자동으로 배정합니다.</p>
                <div className="p-4 my-3 draft-example">
                  <strong>EX) 스네이크 드래프트 예시 (8인 리그)</strong>
                  <ul className="mt-2">
                      <li>1라운드: 1번 → 2번 → ... → 8번</li>
                      <li>2라운드: 8번 → 7번 → ... → 1번</li>
                      <li>3라운드: 1번 → 2번 → ... → 8번</li>
                  </ul>
                </div>
                <p>각 픽에는 시간 제한이 있으며, 시간 내에 선택하지 못하면 AI가 자동으로 선수를 선택합니다. <span className="important-text">드래프트에 꼭 참여하여 당신의 전략을 펼치세요!</span></p>

                <h4>3.2 로스터 구성</h4>
                <div className="row">
                    <div className="col-md-6">
                        <h5>타자 (9명)</h5>
                        <ul>
                            <li>포수 (C): 1명</li>
                            <li>1루수 (1B): 1명</li>
                            <li>2루수 (2B): 1명</li>
                            <li>3루수 (3B): 1명</li>
                            <li>유격수 (SS): 1명</li>
                            <li>외야수 (OF): 3명</li>
                            <li>유틸리티 (UTIL): 1명</li>
                        </ul>
                    </div>
                    <div className="col-md-6">
                        <h5>투수 (8명)</h5>
                        <ul>
                            <li>선발 투수 (SP): 5명</li>
                            <li>구원 투수 (RP): 3명</li>
                        </ul>
                        <h5>벤치 (3명)</h5>
                        <ul>
                            <li>후보 선수: 3명 (포지션 제한 없음)</li>
                        </ul>
                    </div>
                </div>
              </div>

              <div id="section-4" className="mb-5">
                  <h3>4. 선수 교체 및 영입</h3>
                  <h4>4.1 선수 교체</h4>
                  <p>드래프트 이후에도 언제든지 당신의 팀 로스터를 변경할 수 있습니다.</p>
                  <h4>4.2 선수 영입 (업데이트 예정)</h4>
                  <p>다른 구단주님들이 보유하지 않은 자유 계약 선수(FA)를 영입하여 팀을 더욱 강력하게 만들어보세요.</p>
                  <h4>4.3 트레이드 (업데이트 예정)</h4>
                  <p>다른 구단주님들과 선수 트레이드를 진행할 수 있습니다. 트레이드를 요청하면 상대방의 동의가 필요하며, 리그 투표를 통해 최종적으로 성사 여부가 결정됩니다.</p>
              </div>

              {/* Section 5 */}
              <div id="section-5" className="mb-5">
                <h3>5. 본격적인 승부, 게임 가이드</h3>
                <p>드래프트가 완료되었다면, 이제 당신의 전략을 증명하고 승리를 쟁취할 시간입니다! 당신의 선택을 받은 선수들이 매일 밤 어떤 활약을 보여줄지, 예측 불허의 승부가 당신을 기다립니다.</p>
                <h4>5.1 점수 계산</h4>
                <p>'플레이볼 판타지'에서는 선수들의 다양한 기록을 통해 점수를 계산합니다. 득점 방식은 다음과 같습니다.</p>
                
                <h5>타자 점수표</h5>
                <div className="table-responsive">
                    <table className="table table-bordered table-striped align-middle">
                        <thead className="table-light">
                            <tr>
                                <th>기록</th>
                                <th className="text-center">점수</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr><td><span className="point-plus">득점(R), 안타(H), 타점(RBI), 볼넷(BB), 도루(SB) 등</span></td><td className="text-center"><span className="point-plus">+1점</span></td></tr>
                            <tr><td><span className="point-plus">2루타(2B)</span></td><td className="text-center"><span className="point-plus">+2점</span></td></tr>
                            <tr><td><span className="point-plus">3루타(3B)</span></td><td className="text-center"><span className="point-plus">+3점</span></td></tr>
                            <tr><td><span className="point-plus">홈런(HR)</span></td><td className="text-center"><span className="point-plus">+4점</span></td></tr>
                            <tr><td><span className="point-minus">삼진(SO), 도루 실패(CS), 병살타(GDP), 실책(E)</span></td><td className="text-center"><span className="point-minus">-1점</span></td></tr>
                        </tbody>
                    </table>
                </div>

                <h5>투수 점수표</h5>
                 <div className="table-responsive">
                    <table className="table table-bordered table-striped align-middle">
                        <thead className="table-light">
                            <tr>
                                <th>기록</th>
                                <th className="text-center">점수</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr><td><span className="point-plus">투구 이닝 (0.1이닝당)</span></td><td className="text-center"><span className="point-plus">+1점</span></td></tr>
                            <tr><td><span className="point-plus">삼진(SO)</span></td><td className="text-center"><span className="point-plus">+1점</span></td></tr>
                            <tr><td><span className="point-plus">승리(W), 퀄리티 스타트(QS), 홀드(HD)</span></td><td className="text-center"><span className="point-plus">+3점</span></td></tr>
                            <tr><td><span className="point-plus">완투(CG), 완봉(SHO)</span></td><td className="text-center"><span className="point-plus">+4점</span></td></tr>
                            <tr><td><span className="point-plus">세이브(SV)</span></td><td className="text-center"><span className="point-plus">+5점</span></td></tr>
                            <tr><td><span className="point-minus">자책점(ER), 피안타(H), 피홈런(HR), 볼넷(BB) 등</span></td><td className="text-center"><span className="point-minus">-1점</span></td></tr>
                            <tr><td><span className="point-minus">패배(L)</span></td><td className="text-center"><span className="point-minus">-3점</span></td></tr>
                            <tr><td><span className="point-minus">블론 세이브(BS)</span></td><td className="text-center"><span className="point-minus">-5점</span></td></tr>
                        </tbody>
                    </table>
                </div>
              </div>

              {/* Section 6 */}
              <div id="section-6" className="mb-5">
                <h3>6. 팀 관리</h3>
                <h4>6.1 로스터 관리</h4>
                <p>KBO 리그 경기 당일, 첫 경기 시작과 동시에 해당일의 로스터가 확정되어 더 이상 변경할 수 없습니다. 경기 시작 전에 선발 라인업과 벤치 멤버를 꼼꼼히 확인하고, 최상의 라인업을 구성하는 것이 매우 중요합니다. 벤치에 있는 선수는 점수 획득에 반영되지 않습니다.</p>
                <h4>6.2 선수 영입 및 트레이드</h4>
                <p>선수 영입 및 트레이드 기능은 현재 준비 중이며, 곧 업데이트될 예정입니다. 더 강력한 팀을 만들 수 있는 새로운 전략적 요소를 기대해주세요!</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Guide;
